import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import InboundCallNew from './icon-inbound-call-new.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <InboundCallNew {...validProps} />;
}
SvgComponent.iconName = 'inboundCallNew';

export const InboundCallIconNew = svgIconWrapper(SvgComponent);
